<template>
  <!--查看-->
  <div>
    <el-form
      :model="formData"
      :rules="rules"
      v-loading="saveLoading"
      ref="editForm"
      size="small"
      :label-width="'130px'"
      class="form-horizontal detail-form paddingTopDetail employeeEditDetail"
    >
      <el-form-item prop="pushName" label="中心名称：">
        <el-input v-model="formData.pushName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item prop="provinceCode" label="部署区域：">
        <div class="flex-row">
          <el-select
            v-model="formData.provinceCode"
            filterable
            clearable
            placeholder="省"
            popper-class="edit-sel-popper"
            class="m-r-md"
            @change="selectedChange($event, 'getCity', false)"
          >
            <el-option
              v-for="item in region_provinceDicts"
              :key="item.areaCode"
              :label="item.areaName"
              :value="item.areaCode"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="formData.cityCode"
            filterable
            clearable
            placeholder="市"
            class="m-r-md"
            popper-class="edit-sel-popper"
            @change="selectedChange($event, 'getArea')"
          >
            <el-option
              v-for="item in region_cityDicts"
              :key="item.areaCode"
              :label="item.areaName"
              :value="item.areaCode"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="formData.regionCode"
            filterable
            clearable
            placeholder="区（县）"
            class="m-r-md"
            popper-class="edit-sel-popper"
            style="z-index: 8888 !important"
          >
            <el-option
              v-for="item in region_areaDicts"
              :key="item.areaCode"
              :label="item.areaName"
              :value="item.areaCode"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item prop="pushIp" label="IP地址：">
        <el-input v-model="formData.pushIp" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item prop="pushAccount" label="FTP账号：">
        <el-input
          v-model="formData.pushAccount"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item prop="pushPassword" label="FTP密码：">
        <el-input
          v-model="formData.pushPassword"
          :placeholder="detailData.id > 0 ? '不修改密码请留空' : ''"
        ></el-input>
      </el-form-item>
      <el-form-item prop="pushPort" label="FTP端口：">
        <el-input
          v-model.number="formData.pushPort"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item prop="expand" label="备注：">
        <el-input v-model="formData.expand" placeholder="请输入"></el-input>
      </el-form-item>
      <div style="text-align: center; padding: 20px; width: 100%">
        <el-button
          class="submit-btn"
          @click="handleSave(0)"
          >保存</el-button
        >
        <el-button
          class="cancel-btn"
          @click="handleCancel"
          >取消</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import RichText from "@/components/common/RichText/RichText";
import {
  mapActions
} from 'vuex'
import formCheck from '@/components/common/formCheck'
export default {
  components: { RichText },
  mixins: [formCheck],
  name: "pushDetailModel",
  props: {
    selOptions: {
      type: Object,
      default: { cyzjdm: [], rylx: [] },
    },
    detailModal: {
      type: Boolean,
      default: ''
    },
    detailData: {
      type: Object,
      default: {}
    },
    detailType: {
      type: String,
      default: 'show'
    }
  },
  data() {
    let detailKeys = ['pushName', 'pushIp', 'provinceCode', 'cityCode', 'regionCode', 'pushAccount', 'pushPassword', 'pushPort', 'expand', 'areaCode']
    let formData = { pushType: 1 }
    detailKeys.map((key) => {
      formData[key] = ''
    })
    let validateIP = (rule, value, callback) => {
      if (!this.checkIPAddress(value)) {
        callback(new Error('IP格式错误'));
      } else {
        callback();
      }
    };

    return {
      isValid: true,
      activeNames: ['1', '2', '3', '4', '5', '6', '7'],
      showType: '',
      saveLoading: false,
      detailKeys: detailKeys,

      rules: {
        /*'name','pushIp','provinceCode','cityId','regionId','pushAccount','pushPassword','pushPort','expand'*/
        pushName: [{ required: true, message: '请输入', trigger: 'blur' },],
        pushIp: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: validateIP, trigger: 'change' }],
        pushPort: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkPort, trigger: 'change' }],
        provinceCode: [{ required: true, message: '请选择', trigger: 'blur' },],
        pushAccount: [{ required: true, message: '请输入', trigger: 'blur' },],

      },
      region_provinceDicts: [],
      region_cityDicts: [],
      region_areaDicts: [],
      formData: formData
    }
  },
  created() {
    this.initSelData()
  },
  mounted() {
    this.showType = this.detailType
    this.$nextTick(() => {
      this.$refs.editForm.resetFields()
      this.initFormData()
    })
  },
  watch: {
    detailType(val) {
      this.showType = val
    },
    detailModal(val) {
      if (val === false) {
        return false
      }
      this.$nextTick(() => {
        this.$refs.editForm.resetFields()
        this.initFormData()
      })
    }
  },
  methods: {
    ...mapActions([
      'alertToggle',
      'fetchData'
    ]),
    initFormData() {
      if (this.detailType == 'add') {
        this.detailKeys.map((key) => {
          this.formData[key] = ''
        })
      }
      if (this.detailType == 'edit') {
        this.detailKeys.map((key) => {
          if (key == 'pushPassword') {
            this.formData[key] = ''
          } else {
            this.formData[key] = this.detailData[key] ? this.detailData[key] : ''
          }
        })

        //省市区域
        // getCity
        let p1 = this.fetchData({
          url: 'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE',
          method: 'get',
          params: { parentCode: this.detailData.provinceCode }
        })
        //getArea
        let p2 = this.fetchData({
          url: 'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE',
          method: 'get',
          params: { parentCode: this.detailData.cityCode }
        })

        Promise.all([p1, p2]).then(([res1, res2]) => {
          this.handleAreaChange(res1, "getCity", true)
          this.handleAreaChange(res2, "getArea", true)
        }).catch((err) => {
          console.log(err, '------')
        })
      }
    },
    initSelData() {
      //区域
      let sp1 = this.fetchData({
        url: 'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE',
        params: {
          parentCode: '0'
        },
        method: 'get'
      })
      Promise.all([sp1]).then(([rest1]) => {
        this.$nextTick(() => {
          let tempArr = []
          rest1 && rest1.forEach(re => {
            if (re.areaName) {
              tempArr.push({
                value: re.areaCode,
                label: re.areaName,
                areaCode: re.areaCode,
                areaName: re.areaName
              })
            }
          })
          this['region_provinceDicts'] = [...tempArr]
        })

      }).catch((err) => {
        console.log(err, '-----------')
      }).finally(() => {
        this.$nextTick(() => {
          this.saveLoading = false
        })
      })
    },
    handleAreaChange(res, evt, flag) {
      let tempArr = []
      res.forEach(re => {
        if (re.areaName) {
          tempArr.push({
            value: re.areaCode,
            label: re.areaName,
            areaCode: re.areaCode,
            areaName: re.areaName,
          })
        }
      });
      if (evt === 'getCity') {
        this.region_cityDicts = tempArr;
        if (flag) {
          return
        }
        this.formData.cityCode = '';
        this.formData.regionCode = '';
      }
      if (evt === 'getArea') {
        this.region_areaDicts = tempArr;
        if (flag) {
          return
        }
        this.formData.regionCode = '';
      }
    },

    selectedChange(codeValue, evt, flag = false) {
      let url = 'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE'
      let code = codeValue
      let params = { parentCode: code }
      this.fetchData({
        url,
        method: 'get',
        params
      }).then(res => {
        let tempArr = []
        res.forEach(re => {
          if (re.areaName) {
            tempArr.push({
              value: re.areaCode,
              label: re.areaName,
              areaCode: re.areaCode,
              areaName: re.areaName,
            })
          }

        });
        if (evt === 'getCity') {
          this.region_cityDicts = tempArr;
          if (flag) {
            return
          }
          this.formData.cityCode = '';
          this.formData.regionCode = '';
        }
        if (evt === 'getArea') {
          this.region_areaDicts = tempArr;
          if (flag) {
            return
          }
          this.formData.regionCode = '';
        }
      }).catch(err => {
        this.error = err
      })
    },
    //保存
    handleSave(type) {
      this.saveLoading = true
      this.trimFormData()
      this.$refs['editForm'].validate((valid) => {
        if (valid && this.isValid) {
          this.doSave(type)
        } else {
          // this.$message.error('输入不合法！')
          this.saveLoading = false
          return false;
        }
      });
    },
    doSave(type) {

      let url = 'PUSH.CONFIG.POST_SAVE'
      let paramData = { ...this.formData }
      paramData.areaCode = paramData.regionCode || paramData.cityCode || paramData.provinceCode;

      if (this.detailType == 'add') {
        delete paramData.id
      } else {
        paramData.id = this.detailData.id
        if (this.formData.pushPassword.trim() == '') {
          delete paramData.pushPassword
        }
      }

      this.fetchData({ url: url, method: 'post', headers: { "Content-Type": "application/json" }, params: paramData, timeout: 0, isLoading: false, flag: true }).then((res) => {
        if (res.code === 200) {
          this.$message.success('操作成功！')
          this.$emit('submitSuccess')
        } else {
          this.$message.error(res.msg || '操作失败！')
        }
        this.saveLoading = false
      }).catch((err) => {
        this.$message.error('操作失败！')
        this.saveLoading = false
      }).finally(() => {
        this.saveLoading = false
      })
    },
    handleCancel() {
      this.$emit('closeModel')
    },
  },
}
</script>

<style lang="less" scoped>
.employeeEditDetail {
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  width: 90% !important;
}
.employeeEditDetail .el-form-item {
  width: 50% !important;
  .el-select {
    width: 100%;
  }
}
.employeeEditDetail .el-form-item.rowItem {
  width: 100% !important;
}
.employeeEditDetail .detailContent {
  padding: 0px;
}
.sentContent {
  margin: 20px;
  padding: 10px;
  border: 1px solid rgba(38, 118, 165, 1);
}
.sentContentTitle {
  text-align: center;
}
</style>
<style lang="less" >
.employeeEditDetail .w-e-text-container {
  border: 1px solid #2676a5 !important;
}
</style>

